var React = require('react');

function ChevronRightRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"chevron-right-regular","d":"M3.235,34.864,1.671,36.428a.949.949,0,0,0,0,1.341L15.944,52.086,1.671,66.4a.949.949,0,0,0,0,1.341l1.564,1.565a.947.947,0,0,0,1.34,0L21.116,52.756a.949.949,0,0,0,0-1.341L4.575,34.864A.947.947,0,0,0,3.235,34.864Z","transform":"translate(-1.393 -34.586)"}));
}

ChevronRightRegular.defaultProps = {"width":"20","height":"35","viewBox":"0 0 20 35"};

module.exports = ChevronRightRegular;

ChevronRightRegular.default = ChevronRightRegular;
